import React from 'react';
import clsx from '@strava/ui/clsx';
import PropTypes from 'prop-types';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';
import { getProfileVisibility } from '../../helpers/getProfileVisibility';

import styles from './JoinStravaCTA.module.scss';

const JoinStravaCTA = ({ heading, linkConfig, trackConfig, className }) => {
  const { track, state } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete } = athleteData;

  const { href, text } = linkConfig;
  const { element, signupCopy } = trackConfig;

  const handleTrack = () => {
    track({
      action: 'click',
      element,
      properties: {
        profile_visibility: getProfileVisibility(athlete),
        ...(signupCopy && { signup_copy: signupCopy })
      }
    });
  };

  return (
    <div className={clsx(styles.joinStravaCTA, className)}>
      <h4>{heading}</h4>
      <a className={styles.link} href={href} onClick={() => handleTrack()}>
        {text}
      </a>
    </div>
  );
};

JoinStravaCTA.defaultProps = {
  className: null
};

JoinStravaCTA.propTypes = {
  heading: PropTypes.string.isRequired,
  linkConfig: PropTypes.shape({
    href: PropTypes.string,
    text: PropTypes.string
  }).isRequired,
  trackConfig: PropTypes.shape({
    element: PropTypes.string,
    signupCopy: PropTypes.string
  }).isRequired,
  className: PropTypes.string
};

export default JoinStravaCTA;
